AgrimarketServices.service("versionService", ['$http', '$location', 'configurationFactory',
    function($http, $location, configurationFactory) {

    var version = "1.23.34";

    this.webVersion = version;

    var SendRequest = function (configfile, callback) {
      $http(configfile)
        .success(function (data) {
          callback(data, null);
        })
        .error(function (data, status) {
          callback(data, status);
        });
    };

    this.CheckIfUpdateAvailable = function () {
      if ($location.$$url.indexOf("#") >= 0 || $location.$$url.indexOf("/backdoor") >= 0 || $location.$$url.indexOf("/validateCGU") >= 0 || $location.$$url.indexOf("/loginUAC") >= 0 ) return;
      var config = {
        method: "GET",
        url:
          configurationFactory.Url["Api"] +
          "v2/Version/CheckIfUpdateAvailable/" +
          version,
      };
      setTimeout(function () {
        console.log("checking for updates...");
        SendRequest(config, function (data) {
          if (
            data &&
            data.UpdateAvailable == true &&
            $location.$$url.indexOf("#") < 0
          ) {
            console.log("update available, reloading...");
            fullReload(data.LatestVersion);
          } else {
            console.log("no update available");
          }
        });
      }, 3000);
    };
  },
]);
